import { render, staticRenderFns } from "./titleComponent.vue?vue&type=template&id=4443126c&scoped=true"
import script from "./titleComponent.vue?vue&type=script&lang=js"
export * from "./titleComponent.vue?vue&type=script&lang=js"
import style0 from "./titleComponent.vue?vue&type=style&index=0&id=4443126c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4443126c",
  null
  
)

export default component.exports